module.exports = __webpack_public_path__ + "images/avatars/male/5.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/5.png
// module id = fSNa
// module chunks = 55